import * as React from "react"
import "twin.macro"
import { SectionHeading } from "../Headings"
import gracePhoto from "../../images/grace.jpg"
import pratyaPhoto from "../../images/pratya.png"
import billyPhoto from "../../images/billy.png"
import Hero from "./Hero"

export default function AllTestimonials() {
  return (
    <div tw="bg-white overflow-hidden" id="testimonials">
      <div tw="h-20" />
      <SectionHeading tw="text-center">Testimonials</SectionHeading>
      <div tw="h-8" />
      <div tw="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div tw="hidden lg:block bg-gray-50 absolute top-0 bottom-0 left-3/4 w-screen"></div>
        <div tw="mx-auto text-base max-w-prose lg:max-w-none">
          <p tw="text-base leading-6 text-indigo-600 font-semibold tracking-wide uppercase">
            MVFBLA President 17-18
          </p>
          <h1 tw="mt-2 mb-8 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
            Grace Zhou
          </h1>
        </div>
        <div tw="lg:grid lg:grid-cols-3 lg:gap-8">
          <div tw="relative mb-8 lg:mb-0 lg:row-start-1 lg:col-start-3">
            <svg
              tw="hidden lg:block absolute top-0 right-0 -mt-20 -mr-20"
              width="404"
              height="384"
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="de316486-4a29-4312-bdfc-fbce2132a2c1"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    tw="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="384"
                fill="url(#de316486-4a29-4312-bdfc-fbce2132a2c1)"
              />
            </svg>
            <div tw="relative text-base mx-auto max-w-prose lg:max-w-none">
              <div tw="relative pb-7/12 lg:pb-0">
                <img
                  src={gracePhoto}
                  alt=""
                  tw="rounded-lg shadow-lg object-cover object-center absolute inset-0 w-full h-full lg:static lg:h-auto"
                />
              </div>
            </div>
          </div>
          <div tw="lg:col-span-2">
            <div tw="text-base max-w-prose mx-auto lg:max-w-none">
              <p tw="leading-7 text-gray-500 italic mb-5">
                Grace is currently studying at The Wharton School of Business at
                the University of Pennyslvania.
              </p>
              <p tw="text-lg leading-7 text-gray-800 mb-5 font-medium">
                I would not be where I am, or who I am, today if it weren’t for
                my four years in FBLA.
              </p>
            </div>
            <div tw="prose prose-lg text-gray-500 mx-auto lg:max-w-none lg:row-start-1 lg:col-start-1">
              <p>
                It’s easy to reflect on my time in FBLA and point out the
                tangible outcomes it has given me. With support from my fellow
                FBLA members and mentors, I was able to rank top 10 in the
                nation four times competitively and gain leadership skills
                through different officer positions. The stories behind these
                titles helped me find my footing in business as a career path
                and opened the doors to many opportunities, such as my dream
                university and internship roles as well.
              </p>

              <p>
                But, more important than those tangible outcomes are the
                experiences that have shaped my way of thinking and values. For
                one thing, FBLA has taught me how to problem solve in all areas.
                From finding the solution to a business case study in 20
                minutes, to helping an underclassman develop public speaking
                skills, to figuring out how to boost the competitive success of
                the chapter as a whole, I have been able to develop a critical
                and analytical perspective applicable to a variety of
                situations. In addition, I got the chance to learn from the
                diversity of thought and leadership styles present in the
                organization. From the people around me, whether it was the two
                seniors on my team freshman year or my fellow leaders on the
                executive team, I learned how to take initiative and go after my
                goals while also building up confidence and leadership in
                others. FBLA has given me so much, and taught me how to give
                back — it has pushed me to strive forward and become the person
                I am today.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div tw="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div tw="hidden lg:block bg-gray-50 absolute top-0 bottom-0 left-3/4 w-screen"></div>
        <div tw="mx-auto text-base max-w-prose lg:max-w-none">
          <p tw="text-base leading-6 text-indigo-600 font-semibold tracking-wide uppercase">
            MVFBLA Vice President 19-20
          </p>
          <h1 tw="mt-2 mb-8 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
            Pratya Poosala
          </h1>
        </div>
        <div tw="lg:grid lg:grid-cols-3 lg:gap-8">
          <div tw="relative mb-8 lg:mb-0 lg:row-start-1 lg:col-start-3">
            <svg
              tw="hidden lg:block absolute top-0 right-0 -mt-20 -mr-20"
              width="404"
              height="384"
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="de316486-4a29-4312-bdfc-fbce2132a2c1"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    tw="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="384"
                fill="url(#de316486-4a29-4312-bdfc-fbce2132a2c1)"
              />
            </svg>
            <div tw="relative text-base mx-auto max-w-prose lg:max-w-none">
              <div tw="relative pb-7/12 lg:pb-0">
                <img
                  src={pratyaPhoto}
                  alt=""
                  tw="rounded-lg shadow-lg object-cover object-center absolute inset-0 w-full h-full lg:static lg:h-auto"
                />
              </div>
            </div>
          </div>
          <div tw="lg:col-span-2">
            <div tw="text-base max-w-prose mx-auto lg:max-w-none">
              <p tw="leading-7 text-gray-500 italic mb-5">
                Pratya is currently studying neuroscience at Pitzer College.
              </p>
              <p tw="text-lg leading-7 text-gray-800 mb-5 font-medium">
                There is so much of who I am today that I can attribute to
                MVFBLA.
              </p>
            </div>
            <div tw="prose prose-lg text-gray-500 mx-auto lg:max-w-none lg:row-start-1 lg:col-start-1">
              It’s the organization that sparked my interest in social
              entrepreneurship, led me towards meeting some of my closest
              friends and mentors, and equipped me with essential soft skills.
              Looking back, however, it wasn’t just the appeal of winning
              competitions, or the promise that I would gain exposure to the
              business world that stuck out to me the most about FBLA. It was
              that everyone worked together in a frenetic harmony in which they
              cared about the most idiosyncratic details—whether that be the
              font type of a report, the placement of hand gestures in a speech,
              or the rubbing of lucky oranges at conferences—details that would
              seem bizarre to anyone else. It was the raw compassion I had the
              privilege of experiencing and extending when members cheered each
              other on at conferences or spent hours helping each other out with
              their respective competitions. FBLA isn’t just a place to build
              hard or soft skills—it builds people. It pitched me headlong into
              a turbulent journey filled with personal growth, friendship,
              laughter, failure, and success. I’ll forever be grateful for the
              memories and people that made me fall in love with FBLA a little
              more every year:)
            </div>
          </div>
        </div>
      </div>
      <div tw="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div tw="hidden lg:block bg-gray-50 absolute top-0 bottom-0 left-3/4 w-screen"></div>
        <div tw="mx-auto text-base max-w-prose lg:max-w-none">
          <p tw="text-base leading-6 text-indigo-600 font-semibold tracking-wide uppercase">
            MVFBLA VP of Projects 19-20
          </p>
          <h1 tw="mt-2 mb-8 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
            Billy Yang
          </h1>
        </div>
        <div tw="lg:grid lg:grid-cols-3 lg:gap-8">
          <div tw="relative mb-8 lg:mb-0 lg:row-start-1 lg:col-start-3">
            <svg
              tw="hidden lg:block absolute top-0 right-0 -mt-20 -mr-20"
              width="404"
              height="384"
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="de316486-4a29-4312-bdfc-fbce2132a2c1"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    tw="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="384"
                fill="url(#de316486-4a29-4312-bdfc-fbce2132a2c1)"
              />
            </svg>
            <div tw="relative text-base mx-auto max-w-prose lg:max-w-none">
              <div tw="relative pb-7/12 lg:pb-0">
                <img
                  src={billyPhoto}
                  alt=""
                  tw="rounded-lg shadow-lg object-cover object-center absolute inset-0 w-full h-full lg:static lg:h-auto"
                />
              </div>
            </div>
          </div>
          <div tw="lg:col-span-2">
            <div tw="text-base max-w-prose mx-auto lg:max-w-none">
              <p tw="leading-7 text-gray-500 italic mb-5">
                Billy is currently studying computational biophysics at Harvey
                Mudd College.
              </p>
              <p tw="text-lg leading-7 text-gray-800 mb-5 font-medium">
                Four years ago, walking into the business classroom that would
                eventually be my home away from home, I would never have guessed
                the impact that FBLA would have had on me.
              </p>
            </div>
            <div tw="prose prose-lg text-gray-500 mx-auto lg:max-w-none lg:row-start-1 lg:col-start-1">
              As a prospective physics/cs major going to the STEM heavy Harvey
              Mudd College, people are often surprised to hear how passionately
              involved I am with the “business-focused” FBLA. But even though
              FBLA is a business club, it taught me so much more than that. It
              taught me skills from design to public speaking. FBLA taught me
              more about teamwork, project management, and what leadership truly
              means, than anything else in high school. But more than that, it
              taught me the grit I never thought I had, it taught me friendship
              in ways and with people I never expected, and it taught me
              passion. Passion about building, about creating projects. Passion
              about going out and doing things, whether that means creating a
              partnership with one of the biggest companies in the world, or
              starting my own nonprofit organization. While your experiences in
              FBLA might not look the same as mine, I have no doubt you will
              experience the same family that I did. A family that pushes you to
              become the best version of yourself you could possibly imagine. A
              family that cheers you through your highs and cries with you
              through your lows. A family that will be there for you throughout
              your journey, and one I hope will be as precious to you as it was
              to me.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
